import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { ErrorText } from 'components/domain'
import type React from 'react'
import { Controller, type Control, type FieldErrors } from 'react-hook-form'
import { FormLabel } from '../Label/FormLabel'

interface HorizontalRadioGroupProps {
    name: string
    control: Control<any>
    label: string
    options: Array<{ label: string, value: string }>
    defaultValue?: string
    errors: FieldErrors<any>
}

const HorizontalRadioGroup: React.FC<HorizontalRadioGroupProps> = ({
    name,
    control,
    label,
    options,
    defaultValue,
    errors
}) => {
    return (
        <Box mb={2}>
            <FormLabel>{label.toUpperCase()}</FormLabel>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue ?? ''}
                render={({ field }) => (
                    <RadioGroup {...field} row>
                        {options.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                            />
                        ))}
                    </RadioGroup>
                )}
            />
            {(errors[name] != null) && (
                <ErrorText>{String(errors[name]?.message)}</ErrorText>
            )}
        </Box>
    )
}

export default HorizontalRadioGroup
